/** Shown instead of repeating a mark scheme that is already printed in the question. */
export const REVIEW_YOUR_ANSWER_WAS_CORRECT_LABEL = "Your answer was correct";

function plainReviewText(value) {
  if (value == null || typeof value === "object") return "";
  return String(value)
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/p>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&quot;/gi, '"')
    .replace(/[\u2018\u2019]/g, "'")
    .replace(/[\u201c\u201d]/g, '"')
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

/**
 * True when the mark-scheme text is already written in the question or its passage.
 * Short tokens ("4", "yes", "fewer") stay visible as the answer itself.
 */
export function correctAnswerIsAlreadyInQuestion(questionText, correctAnswer, passageText) {
  const answer = plainReviewText(correctAnswer);
  const question = plainReviewText(
    [questionText, passageText].filter((part) => part != null && String(part).trim()).join("\n")
  );
  if (!answer || !question) return false;
  if (answer.length < 12) return false;
  if (!/\s/.test(answer) && answer.length < 24) return false;
  return question.includes(answer);
}

/**
 * When the correct answer is already in the question and the student matched it,
 * review says so instead of "Not answered" or repeating that text.
 */
export function reviewYourAnswerWasCorrectLabel(input = {}) {
  if (input.isPartial) return null;
  if (input.hasDrawing || input.hasInteractive) return null;
  if (!correctAnswerIsAlreadyInQuestion(input.questionText, input.correctAnswer, input.passageText)) {
    return null;
  }
  const student = plainReviewText(input.studentAnswer);
  const correct = plainReviewText(input.correctAnswer);
  const matched = student !== "" && student === correct;
  const markedCorrectWithoutStoredText = input.isCorrect === true && student === "";
  if (!matched && !markedCorrectWithoutStoredText) return null;
  if (matched && input.isCorrect === false) return null;
  return REVIEW_YOUR_ANSWER_WAS_CORRECT_LABEL;
}
